import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7221cad0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "h-adr d-none" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-country-name" }, "Japan", -1))

import { loadScript } from 'vue-plugin-load-script';
  import { onMounted, ref, watch } from 'vue';
  import { YUBINBANGO_URL } from '@/constants';
  import { IAddressAutocompleteData } from './type';
  import _ from 'lodash';

  export interface IEmits {
    (event: 'complete', data: IAddressAutocompleteData): void;
  }
  interface IProps {
    modelValue: string;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    modelValue: null
  },
  emits: ["complete"],
  setup(__props: any, { emit: emits }: { emit: ({
    (event: 'complete', data: IAddressAutocompleteData): void;
  }), expose: any, slots: any, attrs: any }) {

const props = __props as {
    modelValue: string;
  }

  
  
  const streetAddress = ref<HTMLInputElement>();
  const locality = ref<HTMLInputElement>();
  const region = ref<HTMLInputElement>();
  const postalCode = ref<HTMLInputElement>();
  const extendedAddress = ref<HTMLInputElement>();

  const onComplete = _.debounce(() => {
    const form = {
      street_address: [streetAddress.value?.value, extendedAddress.value?.value].filter(Boolean).join(''),
      locality: locality.value?.value,
      region: region.value?.value,
    };
    emits('complete', _.pickBy(form, Boolean));
  }, 500);

  // https://www.id-frontier.jp/blog/tech/web%E3%83%9A%E3%83%BC%E3%82%B8%E3%81%A7%E9%83%B5%E4%BE%BF%E7%95%AA%E5%8F%B7%E3%81%8B%E3%82%89%E4%BD%8F%E6%89%80%E3%82%92%E8%87%AA%E5%8B%95%E5%85%A5%E5%8A%9B%E3%81%99%E3%82%8B%E3%83%A9%E3%82%A4/
  onMounted(async () => {
    await loadScript(YUBINBANGO_URL);
    new window.YubinBango.MicroformatDom;
  });

  watch(() => props.modelValue, () => {
    if (postalCode.value && postalCode.value.setAttribute) {
      postalCode.value.value = props.modelValue || '';
      postalCode.value.dispatchEvent(new Event('keyup', { bubbles: true, cancelable: true }));
      onComplete();
    }
  });


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("input", {
      ref_key: "postalCode",
      ref: postalCode,
      size: "8",
      class: "p-postal-code",
      maxlength: "8"
    }, null, 512),
    _createElementVNode("input", {
      ref_key: "region",
      ref: region,
      class: "p-region"
    }, null, 512),
    _createElementVNode("input", {
      ref_key: "locality",
      ref: locality,
      class: "p-locality"
    }, null, 512),
    _createElementVNode("input", {
      ref_key: "streetAddress",
      ref: streetAddress,
      class: "p-street-address"
    }, null, 512),
    _createElementVNode("input", {
      ref_key: "extendedAddress",
      ref: extendedAddress,
      class: "p-extended-address"
    }, null, 512)
  ]))
}
}

})